import {Box, VStack} from '@indoqa/style-system'
import {History} from 'history'
import * as React from 'react'
import {useHistory} from 'react-router-dom'
import {ajax} from 'rxjs/ajax'
import {authenticator, Permission} from '../../../app/auth/SessionPlusAuthenticator'
import {ResultDocument} from '../../../commons/types/SearchResult'
import {formatDate} from '../../../commons/utils/formatDate'
import {arPathBook} from '../../store/ar.paths'
import {loadAllResources} from '../../store/ar.services'
import {ArInventory} from '../../store/ar.types'
import {getResourceAvailabilityForUser} from '../../utils/getResourceAvailabilityForUser'
import {ArCallToActionPanel} from '../cta/ArCallToActionPanel'
import {getRechtsstand} from '../result-items/utils/getRechtsstand'

export interface ArResourceSection {
  id: string
  heading: React.ReactNode
  filter: (doc: ResultDocument) => boolean
  linked?: boolean
}

interface Props {
  sections: ReadonlyArray<ArResourceSection>
}

const renderBookLink = (doc: ResultDocument, titel: string, history: History, linked: boolean) => {
  const userResourceAvailability = getResourceAvailabilityForUser(doc.availability)
  if (!linked || !userResourceAvailability.available) {
    return (
      <li key={doc.id}>
        {titel}
        <small>&nbsp;(Rechtsstand: {formatDate(getRechtsstand(doc))})</small>
      </li>
    )
  }

  return (
    <li key={doc.id}>
      <a
        href={arPathBook('', doc.id)}
        onClick={(e) => {
          e.preventDefault()
          history.push(arPathBook('', doc.id))
        }}
      >
        {titel}
      </a>
      <small>&nbsp;(Rechtsstand: {formatDate(getRechtsstand(doc))})</small>
    </li>
  )
}

export const ArResourcesPanel = ({sections}: Props) => {
  const isPlusUser = authenticator.hasPermission(Permission.ARFBR_PLUS)
  const isPremiumUser = authenticator.hasPermission(Permission.ARFBR_PREMIUM)
  const isArfbrUser = isPlusUser || isPremiumUser

  const history = useHistory()
  const [arInventory, setArInventory] = React.useState<ArInventory | null>(null)

  React.useEffect(() => {
    loadAllResources(ajax).subscribe((result) => setArInventory(result))
  }, [])

  if (!arInventory) {
    return null
  }

  return (
    <Box fullWidth>
      {!isArfbrUser && <ArCallToActionPanel />}
      <VStack spacing={4}>
        {sections.map((section, index) => (
          <Box key={section.id} pt={index === 0 && !isArfbrUser ? 8 : 0}>
            <h2>{section.heading}</h2>
            <ul>
              {arInventory.books.documents
                ?.filter(section.filter)
                .map((doc) =>
                  renderBookLink(doc, doc.properties.quelle_lang || doc.name, history, section.linked !== false)
                )}
            </ul>
          </Box>
        ))}
      </VStack>
    </Box>
  )
}
